import { GlobalAlert } from '@thoughtspot/global-alert';
import { useTranslation } from '@thoughtspot/i18n';
import { collectEvent, } from '@thoughtspot/metrics';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Icon, IconColor, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, View, } from '@thoughtspot/radiant-react/widgets/layout';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { getClientId } from '@thoughtspot/system-config-service';
import React, { useEffect, useState } from 'react';
import { useGetMfaConfigLazyQuery, useSetMfaTscliCommand, useUpdateMfaConifgMutation, } from '../../../services/saml/saml-service';
import { getDefaultSamlHeaders } from '../constants';
import { getConfigRequestFromProviderConfig, getGroupName, getMixPanelMetric, getProviderConfigFromResponse, MFA_BANNER_FEATURE_NAME, MFA_FEATURE_ID, mfaAcceptedState, OKTA_PROVIDER_OTP, OKTA_PROVIDER_PUSH, providerConfig, providerIdToSortOrder, tscliConfigOperationType, } from './constants';
import styles from './mfa.module.scss';
import { MFAListview } from './mfa-list-view';
export const MFA = () => {
    const { t } = useTranslation();
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [newProviderConfig, setNewProviderConfig] = useState(providerConfig);
    const [mountList, setMount] = useState(false);
    const [screenLoader, setScreenLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [showErrorBanner, setShowErrorBanner] = useState(false);
    const [isToastAlertVisible, setIsToastAlertVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toggleOperation, setToggleOperation] = useState(false);
    const [showModal, shouldShowModal] = useState(false);
    const [mixPanelMetric, setMixPanelMetric] = useState();
    const [configPostData, setConfigPostData] = useState(null);
    const [updateSetting] = useSetMfaTscliCommand(MFA_BANNER_FEATURE_NAME, configPostData);
    const { getMfaConfigInfo, error, loading, MfaConfigInfo, } = useGetMfaConfigLazyQuery();
    const { updateMfaConfig, data: updateMFAResponse, loading: updateMFALoading, error: updateMFAError, } = useUpdateMfaConifgMutation();
    const setMFABannerStatus = (state) => {
        const configPostData = {
            configOperation: tscliConfigOperationType.ADD,
            configOptions: [
                {
                    optionKey: MFA_FEATURE_ID,
                    optionValue: btoa(String(state)),
                    optionLabel: t('mfa.auth.title', { lng: 'en-US' }),
                },
            ],
        };
        setConfigPostData(configPostData);
        updateSetting({
            variables: {
                featureName: MFA_BANNER_FEATURE_NAME,
                params: configPostData,
            },
        });
    };
    const getProviderColumnCustomComponent = (params) => {
        const providerName = params.data.name;
        const rowIdentifier = params.data.sortOrder;
        const description = params.data.description;
        return (React.createElement(Horizontal, { vAlignContent: "center", className: styles.customContent },
            React.createElement(View, { className: styles.icon, vAlignContent: "center", hAlignContent: "center", grow: 0, shrink: 0 },
                React.createElement(Icon, { "data-testid": `mfa-provider-icon-${rowIdentifier}`, id: params.data.icon, size: IconSize.XXLARGE, color: IconColor.BLACK })),
            React.createElement(Vertical, { vAlignContent: "center", className: styles.text },
                React.createElement(Horizontal, { spacing: "b" },
                    React.createElement(Typography, { variant: "content-label-subhead", className: styles.name, "data-testid": `mfa-provider-title-${rowIdentifier}` }, t(providerName))),
                React.createElement(Typography, { "data-testid": `mfa-provider-desc-${rowIdentifier}`, variant: "caption", color: Colors.gray, className: styles.description }, t(description)))));
    };
    const getStatusColumnCustomComponent = (params) => {
        const { context, data } = params;
        return (React.createElement(FormControl, null,
            React.createElement(Toggle, { "data-testid": `mfa-provider-toggle-${data.sortOrder}`, id: `mfaToggle${data.sortOrder}`, checked: newProviderConfig[data.sortOrder].enabled, onChange: event => {
                    context.toggleAction(data);
                }, name: `mfaToggle${data.sortOrder}`, label: t(newProviderConfig[data.sortOrder].enabled
                    ? 'mfa.auth.status.value.enabled'
                    : 'mfa.auth.status.value.disabled'), disabled: false, labelPosition: "right" })));
    };
    const getColumnDefinitions = () => [
        {
            cellRendererFramework: (params) => {
                return getProviderColumnCustomComponent(params);
            },
            headerName: t('mfa.auth.column.authenticators'),
            headerClass: [styles.headerStyle],
            colId: 'Authenticators',
            suppressMovable: true,
            flex: 2,
        },
        {
            cellRendererFramework: (params) => {
                return getStatusColumnCustomComponent(params);
            },
            headerName: t('mfa.auth.column.status'),
            headerClass: [styles.headerStyle],
            colId: 'Status',
            suppressMovable: true,
            flex: 2,
        },
    ];
    const areAllProvidersDisabled = (newProviderUpdate) => {
        return !newProviderUpdate.some((provider) => provider.enabled);
    };
    const isToggleActionValid = (newProviderUpdate) => {
        if (newProviderConfig[providerIdToSortOrder[OKTA_PROVIDER_OTP]]
            .enabled &&
            !newProviderUpdate[providerIdToSortOrder[OKTA_PROVIDER_OTP]].enabled) {
            return !newProviderUpdate[providerIdToSortOrder[OKTA_PROVIDER_PUSH]]
                .enabled;
        }
        return true;
    };
    const getListViewProps = () => {
        return {
            data: newProviderConfig,
            columns: getColumnDefinitions(),
            options: {
                hasCheckboxes: false,
                selectedRowsIds: selectedRowIds,
                suppressMovable: true,
            },
            headerHeight: 32,
            agGridContext: {
                toggleAction: (data) => {
                    setToggleOperation(!data.enabled);
                    const editData = [...newProviderConfig];
                    editData[data.sortOrder] = {
                        ...editData[data.sortOrder],
                        enabled: !editData[data.sortOrder].enabled,
                    };
                    setMixPanelMetric(getMixPanelMetric(editData[data.sortOrder].enabled, editData[data.sortOrder].id));
                    if (!isToggleActionValid(editData)) {
                        setScreenLoader(false);
                        setErrorMessage(t('mfa.auth.push.disable.error'));
                        setShowErrorBanner(true);
                        return;
                    }
                    if (areAllProvidersDisabled(editData)) {
                        shouldShowModal(true);
                        return;
                    }
                    setScreenLoader(true);
                    updateMfaConfig(getConfigRequestFromProviderConfig(editData));
                },
            },
            loading: false,
        };
    };
    const remountProviderList = () => {
        setScreenLoader(true);
        setMount(false);
        setTimeout(() => {
            setScreenLoader(false);
            setMount(true);
        });
    };
    const showToastMessage = () => {
        if (toggleOperation) {
            setToastMessage(t('mfa.auth.enabled.message'));
        }
        else {
            setToastMessage(t('mfa.auth.disabled.message'));
        }
        setIsToastAlertVisible(true);
        setShowErrorBanner(false);
    };
    useEffect(() => {
        if (!loading) {
            if (MfaConfigInfo) {
                setMount(true);
                setNewProviderConfig([
                    ...getProviderConfigFromResponse(MfaConfigInfo),
                ]);
            }
            else if (error) {
                setScreenLoader(false);
                setErrorMessage(t('mfa.auth.fetch.error'));
                setShowErrorBanner(true);
            }
        }
    }, [error, loading, MfaConfigInfo]);
    useEffect(() => {
        if (!updateMFALoading) {
            if (updateMFAResponse) {
                setNewProviderConfig([
                    ...getProviderConfigFromResponse(updateMFAResponse.Data),
                ]);
                showToastMessage();
                collectEvent(mixPanelMetric);
                const areAllDisabled = areAllProvidersDisabled([
                    ...getProviderConfigFromResponse(updateMFAResponse.Data),
                ]);
                setMFABannerStatus(areAllDisabled
                    ? mfaAcceptedState.SHOWBANNER
                    : mfaAcceptedState.ACCEPTED);
            }
            else if (updateMFAError) {
                setErrorMessage(t('mfa.auth.update.error'));
                setShowErrorBanner(true);
                setNewProviderConfig([...newProviderConfig]);
            }
        }
    }, [updateMFAResponse, updateMFALoading, updateMFAError]);
    useEffect(() => {
        if (mountList) {
            remountProviderList();
        }
    }, [newProviderConfig]);
    useEffect(() => {
        setScreenLoader(true);
        getMfaConfigInfo({
            clientId: getClientId(),
            defaultHeaders: getDefaultSamlHeaders(),
            groupName: getGroupName(),
        });
    }, []);
    return (React.createElement(LoadingIndicator.Global, { hideLoader: !screenLoader, loadingText: t('mfa.auth.loading.label'), className: `${styles.loadIndicator} ${screenLoader ? styles.disallowScroll : ''}`, "data-testid": "mfa-provier-loader" },
        React.createElement(Modal, { isOpen: showModal, size: ModalSize.SMALL, title: t('mfa.auth.modal.title'), confirmButton: {
                text: t('mfa.auth.modal.disbale'),
                onConfirm: () => {
                    setScreenLoader(true);
                    providerConfig.forEach((element, index) => {
                        providerConfig[index].enabled = false;
                    });
                    updateMfaConfig(getConfigRequestFromProviderConfig(providerConfig));
                    shouldShowModal(false);
                },
            }, dismissButton: {
                text: t('mfa.auth.modal.cancel'),
            }, onDismiss: () => {
                shouldShowModal(false);
            }, doNotDismissOnOutsideClickOrEsc: true },
            React.createElement(Vertical, null,
                React.createElement(Typography, { "data-testid": "mfa-disablement-dialog", variant: "body-normal", color: Colors.gray, className: styles.description }, t('mfa.auth.disable.warning')))),
        showErrorBanner && (React.createElement(Alert.Banner, { message: errorMessage, isVisible: true, type: BannerAlertType.ERROR, onClose: () => {
                setShowErrorBanner(false);
            } })),
        React.createElement("div", { className: styles.customContent, "data-testid": "mfa-provier-list" }, mountList && (React.createElement(MFAListview, { pageHeading: t('mfa.auth.title'), className: styles.innerContainer, listViewProps: getListViewProps(), pageText: t('mfa.auth.page.text') }))),
        React.createElement(GlobalAlert.Toast, { "data-testid": "toast-message-mfa", message: toastMessage, isVisible: isToastAlertVisible, onClose: () => setIsToastAlertVisible(false), autoHide: true })));
};
//# sourceMappingURL=mfa.container.js.map